import { AxiosInstance, AxiosResponse } from "axios";
import qs from "qs";
import { ApiPath } from "src/api";
import { ContractorNoti } from "../contract/contract-types";
import { ApiResponse } from "../public-types";
import { AutoPaymentResponse, BillingDetail, BillingScheduleList, ScheduleRoundNOverdueListResponse } from "./billing-type";

const getScheduleList = (axios: AxiosInstance, params?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.list;

  return axios.get<ApiResponse<BillingScheduleList>>(path, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { allowDots: true, encode: true }),
    },
  });
};

const getScheduleDetail = (
  axios: AxiosInstance,
  params?: {
    contractId: number;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.scheduleDetail.replace("{contractId}", params!.contractId!.toString());
  return axios.get<ApiResponse<any>>(path, { params });
};

const updateScheduleDetail = (
  axios: AxiosInstance,
  params?: {
    contractId: number;
    body: any;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.scheduleDetail.replace("{contractId}", String(params!.contractId));
  return axios.patch<ApiResponse<any>>(path, params?.body);
};
//
const getScheduleRoundList = (
  axios: AxiosInstance,
  params?: {
    scheduleId: number;
    isAll?: boolean;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.roundList.replace("{scheduleId}", params!.scheduleId!.toString());
  return axios.get<ApiResponse<any>>(path, { params });
};

//
/**RCB21. 회차별 청구/연체/결제 목록 조회*/
const getScheduleRoundNOverdueList = (
  axios: AxiosInstance,
  params?: {
    scheduleId: number;
    buildingId?: string;
  },
): Promise<AxiosResponse<ApiResponse<ScheduleRoundNOverdueListResponse>>> => {
  const path = ApiPath.billing.roundNOverdueList.replace("{scheduleId}", String(params!.scheduleId));
  return axios.get<ApiResponse<any>>(path, { params });
};

const editScheduleRoundList = (
  axios: AxiosInstance,
  body?: {
    scheduleId: number;
    billList: any;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  //console.log("body", body);
  const path = ApiPath.billing.roundList.replace("{scheduleId}", String(body?.scheduleId));
  return axios.patch<ApiResponse<any>>(path, { billList: body?.billList });
};

const editScheduleStop = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log('body',body);
  const path = ApiPath.billing.scheduleStop.replace("{scheduleId}", String(body!.scheduleId));
  return axios.patch<ApiResponse<any>>(path, { ...body.schedule });
};
// const getScheduleStop = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
//   // console.log("body", body);
//   const path = ApiPath.billing.scheduleStop.replace("{scheduleId}", String(body!.scheduleId));
//   return axios.get<ApiResponse<any>>(path);
// };

const getCreditRelation = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log("body", body);
  const path = ApiPath.billing.creaditRelation.replace("{tid}", String(body!.tid));
  return axios.get<ApiResponse<any>>(path);
};

const editTaxInvoiceNumber = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log('body',body);
  const path = ApiPath.billing.changeTaxInvoiceNumber.replace("{scheduleId}", String(body!.scheduleId));
  return axios.patch<ApiResponse<any>>(path, { ...body.data });
};

/**
 * 관리자 메모 조회
 * @param axios
 * @param params
 * @returns
 */
const getContractMemoList = (
  axios: AxiosInstance,
  params?: {
    id: number;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const changeId = ApiPath.contract.detail.memo.list.replace("{serviceId}", params!.id!.toString());
  const path = changeId.replace("{serviceType}", "CT_CONTRACT");
  return axios.get<ApiResponse<any>>(path, { params });
};

const addContractMemo = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log('body',body);
  const send = { memoContent: body.contractMemo };
  const changeId = ApiPath.contract.detail.memo.add.replace("{serviceId}", body!.contractManageId!.toString());
  const path = changeId.replace("{serviceType}", "CT_CONTRACT");
  return axios.post<ApiResponse<any>>(path, { contractMemo: { ...send } });
};

const editContractMemo = (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log('body',body);
  const send = {
    contractMemoId: body.contractMemoId,
    memoContent: body.contractMemo,
    isDeleted: "false",
  };
  const path = ApiPath.contract.detail.memo.edit.replace("{memoId}", body!.contractMemoId!.toString());
  return axios.patch<ApiResponse<any>>(path, { contractMemo: send });
};

/**
 * 회원의 관리자 메모 삭제
 * @param axios
 * @param body
 * @returns
 */
const deleteContractMemo = async (axios: AxiosInstance, body?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  const send = {
    id: body.contractMemoId,
    isDeleted: "true",
  };
  const path = ApiPath.contract.detail.memo.edit.replace("{memoId}", body!.contractMemoId!.toString());
  return axios.patch<ApiResponse<any>>(path, { contractMemo: send });
};

/**
 * RCB92. 자동 즉시결제
 * @param axios
 * @param params
 * @returns
 */
const retryPayment = (
  axios: AxiosInstance,
  params?: {
    billId: number;
  },
): Promise<AxiosResponse<ApiResponse<AutoPaymentResponse>>> => {
  // console.log("params", params);
  const path = ApiPath.billing.retryPayment.replace("{billId}", String(params?.billId));

  return axios.post<ApiResponse<AutoPaymentResponse>>(path, {});
};
const changeRecieve = (
  axios: AxiosInstance,
  params?: {
    scheduleId: number;
    body: any;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log("params", params);
  const path = ApiPath.billing.receipt.replace("{scheduleId}", String(params?.scheduleId));

  return axios.patch<ApiResponse<any>>(path, { receiptList: params?.body });
};

const connectReceive = (axios: AxiosInstance, params?: any): Promise<AxiosResponse<ApiResponse<any>>> => {
  // console.log("params", params);
  const path = ApiPath.billing.creaditConfirm.replace("{contractId}", String(params?.contractId));

  return axios.patch<ApiResponse<any>>(path, [...params?.body.saveCreadits]);
};

/**
 * 2023-09-07 이후 변경된 API대응을 위한 type 정의
 * 상세 정보 조회를 뒤한 API 추가
 * ========================================
 */

/**RCB01. 빌링스케줄 리스트 조회*/
export const getScheduleDetail_RCB01 = (
  axios: AxiosInstance,
  params?: {
    contractId: number;
    supplyType?: string;
    buildingId?: number;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.getBillingSchedule.replace("{contractId}", params!.contractId!.toString());
  return axios.get<ApiResponse<any>>(path, { params });
};

/**RCB02. 빌링스케줄 리스트 수정*/
export const patchScheduleDetail_RC002 = (
  axios: AxiosInstance,
  params?: {
    contractId: number;
    scheduleList: Array<BillingDetail>;
    billContactList?: Array<ContractorNoti>;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.getBillingSchedule.replace("{contractId}", params!.contractId!.toString());
  return axios.patch(path, { billContactList: params?.billContactList, scheduleList: params?.scheduleList });
};

/** RCB41. 청구 페이레터 결제내역 조회 */
export const getPaymentNCancelList = (
  axios: AxiosInstance,
  params?: {
    billId: string;
    pgcode: string;
    isSuccessOnly: boolean;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.getPaymentList.replace("{billId}", params!.billId!);
  return axios.get<ApiResponse<any>>(path, { params });
};

/** RCB93. 페이레터 결제 취소 */
export const paymentCancelRequest = (
  axios: AxiosInstance,
  params?: {
    paymentId: string;
    cancelAmount?: string;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.paymentCancel.replace("{paymentId}", params!.paymentId!);
  return axios.post<ApiResponse<any>>(path, { cancelAmount: params!.cancelAmount! });
};
/**
 * RCZ12. 계산방식 별 공급가/부가세 계산
 * calculateType : basisTotalAmount, basisSupplyAmount
 * amount : number
 */
export const mntCalAmountTax = (
  axios: AxiosInstance,
  params?: {
    calculateType: string;
    amount?: number;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.mntCalculateAmountTax;
  return axios.get<ApiResponse<any>>(path, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { allowDots: true, encode: true }),
    },
  });
};

/** RCB22. 청구서 등록 */
export const mntBillAdd = (
  axios: AxiosInstance,
  params?: {
    scheduleId: string;
    body?: any;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.mntAddOrUpdate_RCB22.replace("{scheduleId}", String(params?.scheduleId));
  return axios.post<ApiResponse<any>>(path, { billList: [params!.body] });
};
/** RCB22. 청구서 수정 */
export const mntBillUpdate = (
  axios: AxiosInstance,
  params?: {
    scheduleId: string;
    body?: any;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.mntAddOrUpdate_RCB22.replace("{scheduleId}", String(params?.scheduleId));
  return axios.patch<ApiResponse<any>>(path, { billList: [params!.body] });
};

/** RCB52. 관리비 청구서 이메일 발송 */
export const mntBillSendEmail = (
  axios: AxiosInstance,
  params?: {
    billId: string;
    isSendNow: boolean;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.mntSendEmail_RCB52.replace("{billId}", String(params?.billId));
  return axios.post<ApiResponse<any>>(path, { isSendNow: params!.isSendNow! });
};

/** RCB61. 국세청 전자세금계산서 발행 */
export const sendTaxInvoiceToNtsAsync = (
  axios: AxiosInstance,
  params?: {
    billId: string;
    invoiceType?: "TAX_PLUS" | "TAX_NONE";
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const invoiceType = params?.invoiceType;

  // invoiceType 있으면 쿼리 추가 / 없으면 세금계산서 , 전자계산서 둘다 발행
  const path =
    ApiPath.billing.mntTaxInvoiceNts_RCB61.replace("{billId}", String(params?.billId)) + (invoiceType ? `?invoiceType=${invoiceType}` : "");
  return axios.post<ApiResponse<any>>(path);
};

//RCZ13. 영업일 확인/조회
export const mntGetWeekDay = (
  axios: AxiosInstance,
  params?: {
    checkDate: string;
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.mntWeekdayCheck_RCZ13;
  return axios.get<ApiResponse<any>>(path, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { allowDots: true, encode: true }),
    },
  });
};

// RCB62. 국세청 전자세금계산서 메일 (재)발송
export const sendTaxInvoiceEmailAsync = (
  axios: AxiosInstance,
  params?: {
    billId: string;
    mgtKey: string; // 세금계산서 발행번호
  },
): Promise<AxiosResponse<ApiResponse<any>>> => {
  const path = ApiPath.billing.sendTaxInvoiceEmail.replace("{billId}", String(params?.billId)) + `?mgtKey=${params?.mgtKey}`;
  return axios.post<ApiResponse<any>>(path);
};

// RCP12. 팝빌 세금계산서 팝업 URL
export const getPopbillTaxInvoiceViewUrlAsync = (
  axios: AxiosInstance,
  params?: {
    mgtKey: string;
  },
): Promise<AxiosResponse<ApiResponse<{ viewUrl: string }>>> => {
  const path = ApiPath.billing.taxInvoiceViewUrl.replace("{mgtKey}", String(params?.mgtKey));
  return axios.get<ApiResponse<any>>(path);
};

export {
  addContractMemo,
  changeRecieve,
  connectReceive,
  deleteContractMemo,
  editContractMemo,
  editScheduleRoundList,
  editScheduleStop,
  editTaxInvoiceNumber,
  getContractMemoList,
  getCreditRelation,
  getScheduleDetail,
  getScheduleList,
  getScheduleRoundList,
  getScheduleRoundNOverdueList,
  retryPayment,
  updateScheduleDetail,
};
